module.exports = __webpack_public_path__ + "static/media/21ECLAC41.2a2ffb7d.jpg";